export const isTauri = (): boolean =>
    typeof window !== "undefined" &&
    ("__TAURI_INTERNALS__" in window || "__TAURI__" in window);

export const isMacOSPlatform = (): boolean => {
    if (typeof navigator === "undefined") return false;
    const platform =
        (navigator as Navigator & { userAgentData?: { platform: string } })
            .userAgentData?.platform ?? navigator.platform;
    return /mac/i.test(platform);
};
